import initialState from "./store";
import actions from "./actions";
import reducer from "./reducer";
import { useReducer, useCallback } from "react";
import { ContextProviderProps } from "../../@types/contexts/context.types";
import { SelectedTab } from "../../@types/contexts/UIContext/store.types";
import UIContext from "./UIContext";

const UIContextProvider = ({ children }: ContextProviderProps) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {
		dashboardHeader: state.dashboardHeader,
		selectedTab: state.selectedTab,
		setDashboardHeader: useCallback((dashboardHeader: string) => {
			dispatch({ type: actions.SET_DASHBOARD_HEADER, payload: { ...state, dashboardHeader } });
		}, []),
		setSelectedTab: useCallback((selectedTab: SelectedTab) => {
			dispatch({ type: actions.SET_SELETED_TAB, payload: { ...state, selectedTab } });
		}, []),
		member: state.member,
		setMemberUI: useCallback(
			(member: {
				firstName: string;
				lastName: string;
				role: "EMPLOYEE" | "DEPENDENT";
				employeeId: string | null;
			}) => {
				dispatch({ type: actions.SET_MEMBER, payload: { ...state, member } });
			},
			[]
		),
		provider: state.provider,
		setProviderUI: useCallback((provider: { firstName: string; lastName: string; taxId: string }) => {
			dispatch({ type: actions.SET_PROVIDER, payload: { ...state, provider } });
		}, [])
	};

	return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export default UIContextProvider;
